import {
  SCORM_UPLOAD,
  SCORM_UPLOAD_SUCCESS,
  SCORM_UPLOAD_ERROR,
} from './type'

const initialState = {
  uploading: false,
  uploadedPackage: null,
  error: null,
}

const scormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCORM_UPLOAD:
      return { ...state, uploading: true, error: null }
    case SCORM_UPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploadedPackage: action.payload.response,
      }
    case SCORM_UPLOAD_ERROR:
      return { ...state, uploading: false, error: true }
    default:
      return state
  }
}

export default scormReducer
